/**
 * Bucket cache for `all__element-visibility_intersection-observer__web`.
 *
 * The bucket is read once from Statsig by the user-aware provider and pushed in here, so
 * `useTrackIsElementVisible` — mounted by ~125 consumers across PDP, recommendations, reviews,
 * product lists and CMS sections — never calls Statsig per instance. Control, which is also the
 * value on the server and through hydration, keeps the historical document-scroll listener, so a
 * rollback is a bucket flip with no code change.
 *
 * Consumers subscribe rather than read once. Above-the-fold consumers mount at hydration, before
 * the client-side Statsig bucket resolves; reading a single time would pin exactly those to Control
 * and dilute the Test arm where the change matters most.
 */
let isIntersectionObserverEnabled = false

const subscribers = new Set<() => void>()

export const setElementVisibilityIntersectionObserverEnabled = (enabled: boolean): void => {
  if (enabled === isIntersectionObserverEnabled) return
  isIntersectionObserverEnabled = enabled
  subscribers.forEach(notify => {
    notify()
  })
}

export const subscribeToElementVisibilityIntersectionObserver = (notify: () => void): (() => void) => {
  subscribers.add(notify)
  return () => {
    subscribers.delete(notify)
  }
}

export const getElementVisibilityIntersectionObserverEnabled = (): boolean => isIntersectionObserverEnabled

// Control through SSR and hydration — the server has no client bucket, and a differing snapshot
// would make `useSyncExternalStore` tear.
export const getElementVisibilityIntersectionObserverServerSnapshot = (): boolean => false

// Test-only: module state outlives a single test file's cases.
export const resetElementVisibilityIntersectionObserverForTests = (): void => {
  isIntersectionObserverEnabled = false
  subscribers.clear()
}
